<template>
  <div
    id="app"
    :class="{
      'scroll-down': !scrollUp,
      'scroll-up': scrollUp
    }"
  >
    <side-bar />
    <main class="main">
      <div
        class="main__overlay"
        :class="{ 'main__overlay--active': menuActive }"
        @click="toggleMenu"
      ></div>
      <div
        class="branding l-section l-section--centered"
        :class="{
          'branding--slim': !showHeader,
          'branding--top': !topHeader
        }"
      >
        <div
          @click="toggleMenu"
          class="open-menu"
          :class="{ 'open-menu--hover': hoverClass }"
        >
          <svgicon
            class="open-menu__icon"
            icon="menu"
            width="26"
            height="36"
            color="#151515"
          >
          </svgicon>
        </div>
        <div class="l-section__inner">
          <div ref="headerTitle" class="branding__title">
            <router-link to="/">
              <img
                class="branding__title-img"
                src="./assets/TubeChopper_title.png"
                alt="TubeChopper"
              />
            </router-link>
          </div>
          <div class="branding__nav" id="nav">
            <img
              class="branding__disc"
              src="/assets/tubechopper_disc.png"
              alt="TubeChopper disc"
            />
            <router-link to="/">Home</router-link>
            <router-link to="/manual">Manual</router-link>
            <router-link to="/changelog">Changelog</router-link>
          </div>
        </div>
      </div>
      <div class="content">
        <router-view />
      </div>
    </main>
    <footer class="footer">
      <div class="footer__credits">
        <a href="http://www.particle-in-a-box.com" target="_blank">
          <img
            class="footer__logo"
            src="assets/logo_full--color.svg"
            alt="Particle in a Box logo"
          />
        </a>
      </div>
    </footer>
    <GlobalEvents @keydown="pressKey" />
    <CookieConsent>
      <template slot="message">
        This website uses cookies and local storage for certain functions of the
        app.
        <a
          role="button"
          href="http://cookiesandyou.com"
          target="_blank"
          rel="noopener"
          class="cookie-consent-link"
        >
          Learn more
        </a>
      </template>
    </CookieConsent>
  </div>
</template>

<script>
import GlobalEvents from "vue-global-events";
import SideBar from "@/components/SideBar.vue";
import CookieConsent from "vue-cookieconsent-component";
import "@/compiled-icons/menu";

export default {
  components: {
    SideBar,
    GlobalEvents,
    CookieConsent
  },
  data() {
    return {
      hoverClass: false,
      showHeader: true,
      topHeader: false,
      scrollUp: false,
      lastScrollPosition: 0
    };
  },
  computed: {
    menuActive() {
      return this.$store.state.config.menuActive;
    }
  },
  methods: {
    openMenuHover() {
      this.hoverClass = !this.hoverClass;
    },
    toggleMenu() {
      this.$store.commit("toggleMenu");
    },
    escapeKeyListener: function(evt) {
      if (evt.keyCode === 27) {
        this.$store.state.config.setMode = false;
        this.$store.state.config.clearMode = false;
        this.$store.state.config.nudgeMode = false;
        this.$store.commit("closeMenu");
      }
    },
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return false;
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 30) {
        return false;
      }
      this.showHeader = currentScrollPosition < 30; // set classes below 30 pixels
      this.topHeader = currentScrollPosition < 30; // set classes below 30 pixels
      this.scrollUp = currentScrollPosition < this.lastScrollPosition; // Set scroll direction class
      this.lastScrollPosition = currentScrollPosition;
    },
    pressKey(evt) {
      if (evt.keyCode === 77) {
        // Press escape key
        this.$store.commit("toggleMenu");
      } else if (evt.keyCode === 69) {
        // Press E
        this.$store.dispatch("playNote", "C");
      } else if (evt.keyCode === 82) {
        // Press R
        this.$store.dispatch("playNote", "C#");
      } else if (evt.keyCode === 84) {
        // Press T
        this.$store.dispatch("playNote", "D");
      } else if (evt.keyCode === 89) {
        // Press Y
        this.$store.dispatch("playNote", "D#");
      } else if (evt.keyCode === 68) {
        // Press D
        this.$store.dispatch("playNote", "E");
      } else if (evt.keyCode === 70) {
        // Press F
        this.$store.dispatch("playNote", "F");
      } else if (evt.keyCode === 71) {
        // Press G
        this.$store.dispatch("playNote", "F#");
      } else if (evt.keyCode === 72) {
        // Press H
        this.$store.dispatch("playNote", "G");
      } else if (evt.keyCode === 67) {
        // Press C
        this.$store.dispatch("playNote", "G#");
      } else if (evt.keyCode === 86) {
        // Press V
        this.$store.dispatch("playNote", "A");
      } else if (evt.keyCode === 66) {
        // Press B
        this.$store.dispatch("playNote", "A#");
      } else if (evt.keyCode === 78) {
        // Press N
        this.$store.dispatch("playNote", "B");
      }
    }
  },
  beforeCreate() {
    this.$store.commit("initializeStore");
  },
  created: function() {
    document.addEventListener("keydown", this.escapeKeyListener);
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  destroyed: function() {
    document.removeEventListener("keydown", this.escapeKeyListener);
  }
};
</script>

<style lang="scss">
@import "partials/base";
$cookieconstent-compliance-border: 0;
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent";
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-bottom";
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-transition";

.cookie-consent-link {
  padding-left: 5px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  color: #151515;
}

a {
  color: $color-active;
  text-decoration: none;
  &:hover {
    color: $color-active;
    text-decoration: none;
  }
}
.branding {
  width: 100%;
  position: fixed;
  z-index: 5;
  background: rgb(44, 218, 186);
  background: linear-gradient(
    90deg,
    rgba(44, 218, 186, 1) 0%,
    rgba(127, 255, 212, 1) 62%,
    rgba(0, 212, 255, 1) 100%
  );
  padding: 25px 0 0;
  transition: 0.15s all ease-in;
  height: 110px;
  box-shadow: none;

  .open-menu {
    position: absolute;
    width: 62px;
    height: 100%;
    top: 0;
    padding-left: 15px;
    z-index: 10;
    transition: all 0.2s ease-out 0s;
    cursor: pointer;

    &:hover {
      background: rgb(44, 218, 186);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.5) 0%,
        rgba(44, 218, 186, 0.2) 100%
      );

      .open-menu__icon {
        transform: translateX(-10px);
      }
    }

    &__icon {
      height: 40px;
      width: 30px;
      position: absolute;
      bottom: 37px;
      pointer-events: none;
      transition: 0.15s all ease-in 0.3s;
    }
  }

  // Customize easing transition in and out
  .scroll-down & {
    transition-delay: 0.2s;
  }

  &--slim {
    transform: translate3d(0, -63%, 0);

    .open-menu__icon {
      bottom: 0;
      transition: 0.15s all ease-in 0s;
    }
  }

  &--top {
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
  }

  &__video-title {
    text-transform: uppercase;
    &:before,
    &:after {
      content: "- ";
    }
  }
  &__nav {
    padding-bottom: 7px;
    text-align: left;
    position: absolute;
    bottom: 0;

    @media (max-width: $break-medium) {
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      text-align: center;
    }

    a {
      margin: 0 20px 0 0;
      font-weight: bold;
      color: #151515;
      transition-property: color;
      transition-duration: 0.5s;
      &.router-link-exact-active {
        color: $color-active;
        text-decoration: none;
      }
    }
  }

  &__title {
    margin-top: 0;
    position: absolute;
    margin-left: -5px;

    @media (max-width: $break-medium) {
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      text-align: center;
    }

    // Customize easing transition in and out
    .scroll-up & {
      transition: 0.35s all ease-in 0s;
    }
    .scroll-down & {
      transition: 0.25s all ease-in 0s;
    }

    &-img {
      max-width: 300px;

      @media (max-width: $break-small) {
        width: 300px;
        max-width: 90%;
      }
    }

    .branding--slim & {
      transform: translate3d(0, -150px, 0);
    }
  }

  &__disc {
    display: none;
    position: absolute;
    width: 60px;
    bottom: -28px;
    left: -380px;
    opacity: 0;
    border-radius: 45px;
    transform: rotate(-60deg);

    // Customize easing transition in and out
    .scroll-down & {
      transition: transform 0.3s ease-out 0.5s, opacity 0.3s ease-out 0.5s,
        left 1s cubic-bezier(0.01, 1.03, 0.01, 1) 0.5s; // custom easing
    }
    .scroll-up & {
      transition: transform 1.2s ease-out 0s, opacity 0.5s ease-in 0.35s,
        left 1s ease-in 0s;
    }

    .branding--slim & {
      left: -90px;
      opacity: 1;
      transform: rotate(0);
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);

      @media (max-width: $break-medium) {
        left: 30px;
      }
      @media (max-width: $break-xs) {
        opacity: 0;
      }
    }
  }
}
.content {
  padding-top: 120px;
}
.main {
  &__overlay {
    transition: all 0.3s ease-out 0s;
    &--active {
      background-color: rgba(0, 0, 0, 0.8);
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 7;
    }
  }
}
.footer {
  background-color: $color-gray-ddd;
  min-height: 120px;
  padding: 35px 20px;
  color: #ffffff;

  &__credits {
    text-align: right;
  }

  &__logo {
    max-width: 240px;
  }
}
</style>
